// src/api/workshopApi.js
import { workshopMockData } from "./mock/workshopData";

/**
 * Mengambil semua data workshop
 * Nantinya fetch(`${process.env.REACT_APP_API_URL}/workshops`)
 */
export const getDataByAll = () => {
  return new Promise((resolve) => {
    // Simulasi delay jaringan agar loading spinner terlihat
    setTimeout(() => {
      resolve(workshopMockData);
    }, 600);
  });
};

/**
 * Mengambil detail workshop berdasarkan ID
 */
export const getWorkshopById = (id) => {
  return new Promise((resolve) => {
    const workshop = workshopMockData.find((ws) => ws.id === id);
    setTimeout(() => resolve(workshop), 300);
  });
};

/**
 * Simulasi update status workshop (misal: On/Off untuk Bundling)
 */
export const updateWorkshopStatus = (id, status) => {
  return new Promise((resolve) => {
    console.log(`Updating workshop ${id} to status: ${status}`);
    setTimeout(() => resolve({ success: true }), 500);
  });
};